import axios from "axios";
import { web } from "./middleware";
import { API_BASE } from "../constants/api";
import { data } from "jquery";

export const AuthApi = {
  login: (data) => axios.post(`${API_BASE}/login`, data),
  logout: () => web({ url: "/user/logout", method: "POST" }),
  register: (data) => axios.post(`${API_BASE}/register-agora`, data),
  forgotPassword: (data) => axios.post(`${API_BASE}/forgot-password`, data),
  changePassword: (data) =>
    web({ url: "/user/update/password", method: "POST", data }),
  checkUnique: (data) => axios.post(`${API_BASE}/check-unique`, data),
  refresh: (token) =>
    axios({
      method: "post",
      url: `${API_BASE}/refresh`,
      data: {
        token,
      },
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }),
};
